import { blogRoutes } from '@/Blog/blog.routes';
const blogModule = {
    routes: blogRoutes
};
export default blogModule;
